
import { ENDPOINTS } from 'constants/endpoints';
import { CommonTitleDiv, WhiteCardWrapper, FormErrorMessageSpan, InputMintDiv, SuccessMessageSpan } from 'views/common-styled-components';
import { ProfileProgressStepsList } from 'constants/progress-steps-constants';
import OnboardingProgressSteps from 'components/onboarding-progress-steps';
import ProfileViewSelector from '../profile-view.selector';
import { propsToJS } from '__utils/immutable-to-js';
import React, { useState, useEffect } from 'react';
import { isBtoCFlow } from '__utils/common-utils';
import styled from 'styled-components';
import { SuccessButton } from 'components/button';
import { useHistory } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import '../../../font-icon.css';
import * as profileviewActions from '../profile-view.actions';
import { getEncryptedUserId } from '__utils/common-utils';
import { getDefaultHeaders, post, get } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import resolveURLParams from '__utils/url-params-resolver';
import CartSummary from 'components/cart-summary/index';
import { CommonStyledComponentProps } from '__utils/type';
import moment from 'moment';
import { useDeepCompare } from 'hooks/use-deep-memo';
import { getDataFromKycCookie } from '__utils/storage';
import { compareGenderData, isAgeBelow18 } from '__utils/helpers';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode, getUserDetails } from '__utils/storage';
import { Row, Col } from 'antd';
import { LayoutContext } from 'components/app-routes';
import useFlashToggler from 'hooks/use-flash-toggler';
import CustomRadio from 'components/custom-radio';


const PersonalDetailsWhiteCard = styled.div<CommonStyledComponentProps>`   
    .desc {
        font-size: 16px;
        font-weight: normal;
        line-height: normal;
        color: #52585a;
            
    }
    h3 {
        font-weight: 600;
        font-size: 18px;
    }
    .genderSlab{
        width: ${(props: any) => !props.isMobile ? "500px" : ""};
        display: flex;
    }
`;
const PersonalDetailsSubmitButton = styled(SuccessButton) <CommonStyledComponentProps>`
    width: 150px;
    margin-top: 1rem;
    font-size: 14px; 
`;
const PersonalFormSection = styled.div<CommonStyledComponentProps>`
     width: ${(props: any) => props.isMobile ? '100%' : '73%'};  
`;

const PersonalDetails: React.FC = () => {
    const history = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const dispatch = useDispatch();
    const { register, handleSubmit, formState: { errors }, control, setValue } = useForm({ mode: 'onChange' });
    // eslint-disable-next-line
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const { profileView, nameInHeader } = propsToJS(useSelector(ProfileViewSelector));
    const [pinCodeErr, setPinCodeErr] = useState<boolean>(false);
    const [radioButtonChecked, setRadioButtonChecked] = useState<any>("");
    const [underAge, setUnderAge] = useState<boolean>(false);
    const [pinAddress, setPinAddress] = useState<any>();
    const flash = useFlashToggler();


    useEffect(() => {
        SetLayoutProps({
            config: { title: 'Investor Profile' }
        })
        dispatch(profileviewActions.fetchGetProfileView(getEncryptedUserId()));
        Mixpanel.track(getEventName("personalDetails", "loaded", "checkout"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
        })
    }, []);

    useEffect(() => {
        if (profileView) {
            setRadioButtonChecked(profileView?.gender);
            if (profileView?.dob) {
                setValue('dob', profileView?.dob);
                setUnderAge(isAgeBelow18(profileView?.dob));
            }
            profileView?.name && setValue('name', profileView?.name);
            profileView?.pincode && validatePincode(profileView?.pincode);
        }
    }, [useDeepCompare(profileView)]);

    const convertUTCToLocalDate = (date: any) => {
        if (!date) {
            return date
        }

        var dateObj = moment(date).format('YYYY-MM-DD');
        return (dateObj + 'T00:00:00.000Z');
    }

    const validatePincode = (pincode: any) => {
        setPinAddress(false); setPinCodeErr(false);
        if (pincode && profileView?.registeredWithBse !== 3) {
            get(resolveURLParams(ENDPOINTS.GET_VERIFY_PINCODE, { pincode: pincode }, null),
                getDefaultHeaders(),
                true
            ).subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.operationMessage === "true") {
                    setPinCodeErr(false);
                    setPinAddress({ ...pinAddress, city: response?.response?.responseData?.city, state: response?.response?.responseData?.state });
                }
                else if (response?.response?.operationMessage === 'false') {
                    setPinCodeErr(true);
                }

            }, (error: AjaxError) => {
                flash.error("Pincode validation Failed. Please try again later.")
            });
        }
    };

    const onSubmitPersonalDetails = (data: any) => {
        setUnderAge(isAgeBelow18(data?.dob));
        if (profileView?.registeredWithBse === 3) {
            history.push('/profile/bank-details');
        }
        else if (pinAddress && !isAgeBelow18(data?.dob)) {
            Mixpanel.track(getEventName("personalInfo", "completed", "checkout"), {
                agentCode: getAgentCode(),
                user: getUserDetails(),
                isBtoCFlow: isBtoCFlow(),
            });

            const personalDetailsData = profileView?.pan ? { ...profileView, ...{ gender: data?.gender, name: nameInHeader, primaryEmail: data?.primaryEmail, dob: convertUTCToLocalDate(data?.dob), address: data?.address.substring(0, 40), pincode: data?.pincode, emailDeclarationFlag: data?.emailDeclarationFlag, mobileDeclarationFlag: data?.mobileDeclarationFlag } } :
                { ...profileView, ...{ pan: getDataFromKycCookie()?.pan, panStatus: getDataFromKycCookie()?.rawStatus, gender: data?.gender, name: nameInHeader, primaryEmail: data?.primaryEmail, dob: convertUTCToLocalDate(data?.dob), address: data?.address.substring(0, 40), pincode: data?.pincode,emailDeclarationFlag: data?.emailDeclarationFlag, mobileDeclarationFlag: data?.mobileDeclarationFlag } };
            post(resolveURLParams(ENDPOINTS.POST_SAVE_PROFILE_DETAILS, {}, { ucc: getEncryptedUserId() }), personalDetailsData, getDefaultHeaders(), true)
                .subscribe((response: AjaxResponse | AjaxError) => {
                    if (response?.status === 200) {
                        history.push('/profile/bank-details');
                    }
                    else {
                        flash.error("Something went wrong. Please try again later")
                    }
                }, (error: AjaxError) => {
                    flash.error("Something went wrong. Please try again later")
                });
        }
    };

    const flagMapping: Record<string, string> = {
        "SE": "Self",
        "SP": "Spouse",
        "DC": "Dependent Children",
        "DS": "Dependent Siblings",
        "DP": "Dependent Parents",
        "GD": "Guardian",
        "PM": "PMS",
        "CD": "Custodian",
        "PO": "POA"
    };

    const selectedEmailFlag = flagMapping[profileView?.emailDeclarationFlag] || "Self";
    const selectedMobileFlag = flagMapping[profileView?.mobileDeclarationFlag] || "Self";

    return (<div>
        <WhiteCardWrapper isMobile={isMobile} fullWidth>
            <PersonalDetailsWhiteCard isMobile={isMobile}>
                {!isMobile && <CartSummary />}
                {!isMobile && <CommonTitleDiv>Investor Profile</CommonTitleDiv>}
                <PersonalFormSection isMobile={isMobile} >
                    <OnboardingProgressSteps
                        stepsList={ProfileProgressStepsList}
                        currentStep={0}
                    />
                    <div className="text">
                        <form name="personalDetailsForm" onSubmit={handleSubmit(onSubmitPersonalDetails)}>
                            <Row>
                                <Col xs={24} style={{ margin: '7px 0px' }}>
                                    <p>Gender</p>
                                </Col>
                                <Col xs={24}>
                                    <div className="flex-row">
                                        <CustomRadio
                                            name='gender'
                                            label="Male"
                                            value="Male"
                                            checked={radioButtonChecked && compareGenderData(radioButtonChecked, 'm')}
                                            radiobuttonRef={register({
                                                required: "Please enter your gender.",
                                            })}
                                            disabled={profileView?.registeredWithBse === 3}
                                            onChange={e => setRadioButtonChecked(e.currentTarget.value)}
                                        />
                                        <CustomRadio
                                            name='gender'
                                            label="Female"
                                            value="Female"
                                            radiobuttonRef={register({
                                                required: "Please enter your gender.",
                                            })}
                                            checked={radioButtonChecked && compareGenderData(radioButtonChecked, 'f')}
                                            disabled={profileView?.registeredWithBse === 3}
                                            onChange={e => setRadioButtonChecked(e.currentTarget.value)}
                                        />
                                    </div>
                                </Col>
                            </Row><br/>
                            {(errors.gender) ? <FormErrorMessageSpan style={{ marginBottom: "20px" }}>{errors.gender.message}</FormErrorMessageSpan> : null}

                            <Row gutter={24}>
                                <Col xs={24} md={10}>
                                    <InputMintDiv>
                                        <label>Full Name</label>
                                        <br />
                                        <input
                                            name='name'
                                            type="text"
                                            disabled
                                            placeholder="Enter Full Name"
                                            defaultValue={nameInHeader}
                                            ref={register({
                                                required: "Please enter your full name",
                                            })}
                                        />
                                        {(errors.name) ? <FormErrorMessageSpan>{errors.name.message}</FormErrorMessageSpan> : null}
                                    </InputMintDiv>
                                </Col>
                                <Col xs={24} md={10}>
                                    <InputMintDiv>
                                        <label>Date of Birth</label>
                                        <br />
                                        <Controller
                                            control={control}
                                            name='dob'
                                            defaultValue={profileView?.dob}
                                            rules={{ required: true }}
                                            render={({ onChange, value }) => (
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    yearDropdownItemNumber={100}
                                                    scrollableYearDropdown={true}
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    placeholderText='DD/MM/YYYY'
                                                    disabled={profileView?.registeredWithBse === 3}
                                                    onChange={(date) => onChange(date)}
                                                    onBlur={(e) => {
                                                        setUnderAge(isAgeBelow18(e.target.value));
                                                    }}
                                                    selected={value}
                                                    maxDate={moment().subtract(18, 'years').toDate()}
                                                />
                                            )}
                                        />
                                        {errors.dob ? <FormErrorMessageSpan>Please enter your date of birth</FormErrorMessageSpan> : null}
                                        {underAge ? <FormErrorMessageSpan style={{ fontSize: "13px" }}> You must be 18 years and above </FormErrorMessageSpan> : null}
                                    </InputMintDiv>
                                </Col>
                                
                            </Row>
                            <Row gutter={24}>

                                <Col xs={24} md={10}>
                                    <InputMintDiv>
                                        <label>Mobile Number</label>
                                        <br />
                                        <input
                                            name='primaryMobile'
                                            type="number"
                                            disabled
                                            placeholder="Enter your number"
                                            defaultValue={profileView?.primaryMobile}
                                            ref={register({
                                                required: "Please enter your mobile number",
                                            })}
                                        />
                                        {(errors.primaryMobile) ? <FormErrorMessageSpan>{errors.primaryMobile.message}</FormErrorMessageSpan> : null}
                                    </InputMintDiv>
                                </Col>

                                <Col xs={24} md={10}>
                                    <InputMintDiv>
                                        <label>Mobile Declaration Flag</label>
                                        <br />
                                        <select
                                            name="mobileDeclarationFlag"
                                            defaultValue={ profileView?.mobileDeclarationFlag || "SE"}
                                            disabled={false}
                                            ref={register({
                                                required: "Please select a declaration flag",
                                            })}
                                            style={{
                                                width: "100%",
                                            }}
                                        >
                                            <option value={ profileView?.mobileDeclarationFlag || "SE"}>
                                                {selectedMobileFlag}
                                            </option>
                                            
                                            {Object.entries(flagMapping).map(([code, label]) => {
                                                if (label !== selectedMobileFlag) {
                                                    return (
                                                        <option key={code} value={code}>
                                                            {label}
                                                        </option>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </select>
                                        {errors.mobileDeclarationFlag ? (
                                            <FormErrorMessageSpan>{errors.mobileDeclarationFlag.message}</FormErrorMessageSpan>
                                        ) : null}
                                    </InputMintDiv>
                                </Col>
                                
                            </Row>
                            <Row gutter={24}>

                                <Col xs={24} md={10}>
                                    <InputMintDiv>
                                        <label>Email ID</label>
                                        <br />
                                        <input
                                            name='primaryEmail'
                                            type="email"
                                            disabled={profileView?.registeredWithBse === 3}
                                            placeholder="Enter Email Id"
                                            defaultValue={profileView?.primaryEmail}
                                            ref={register({
                                                required: "Please enter email id",
                                                pattern: {
                                                    value: /^.+@[^.].*\.[a-z]{2,}$/,
                                                    message: "Please enter a valid email"
                                                }
                                            })}
                                        />
                                        {errors.primaryEmail ? <FormErrorMessageSpan>{errors.primaryEmail.message}</FormErrorMessageSpan> : null}
                                    </InputMintDiv>
                                </Col>
                                
                                <Col xs={24} md={10}>
                                    <InputMintDiv>
                                        <label>Email Declaration Flag</label>
                                        <br />
                                        <select
                                            name="emailDeclarationFlag"
                                            defaultValue={profileView?.emailDeclarationFlag || "SE"}
                                            disabled={false}
                                            ref={register({
                                                required: "Please select a declaration flag",
                                            })}
                                            style={{
                                                width: "100%",
                                            }}
                                        >
                                            <option value={profileView?.emailDeclarationFlag || "SE"}>
                                                {selectedEmailFlag}
                                            </option>
                                            
                                            {Object.entries(flagMapping).map(([code, label]) => {
                                                // console.log("Flag option code:", code, "label:", label);
                                            if (label !== selectedEmailFlag) {
                                                return (
                                                <option key={code} value={code}>
                                                    {label}
                                                </option>
                                                );
                                            }
                                            return null;
                                            })}
                                        </select>
                                        {errors.emailDeclarationFlag ? (
                                            <FormErrorMessageSpan>{errors.emailDeclarationFlag.message}</FormErrorMessageSpan>
                                        ) : null}
                                    </InputMintDiv>
                                </Col>
                            </Row>
                            
                            <Row gutter={24}>
                                
                                <Col xs={24} md={10}>
                                    <InputMintDiv>
                                        <label>Address</label>
                                        <br />
                                        <input
                                            name='address'
                                            type="text"
                                            defaultValue={profileView?.address}
                                            placeholder="Enter address"
                                            disabled={profileView?.registeredWithBse === 3}
                                            ref={register({
                                                required: "Please enter address",
                                                maxLength: {
                                                    value: 40,
                                                    message: "Please enter 40 characters only"
                                                }
                                            })}
                                        />
                                        {errors.address ? <FormErrorMessageSpan>{errors.address.message}</FormErrorMessageSpan> : null}
                                    </InputMintDiv>
                                </Col>
                                <Col xs={24} md={10}>
                                    <InputMintDiv>
                                        <label>Pincode</label>
                                        <br />
                                        <input
                                            name='pincode'
                                            type="number"
                                            disabled={profileView?.registeredWithBse === 3}
                                            onMouseLeave={(e: any) => { validatePincode(e.target.value) }}
                                            onKeyUp={(e: any) => { setPinCodeErr(false); setPinAddress(false); }}
                                            placeholder="Enter pincode"
                                            defaultValue={profileView?.pincode}
                                            ref={register({
                                                required: "Please enter your pincode",
                                            })}
                                        />
                                        {errors.pincode ? <FormErrorMessageSpan >{errors.pincode.message}</FormErrorMessageSpan> : null}
                                        {pinCodeErr ?
                                            <FormErrorMessageSpan>Invalid pincode</FormErrorMessageSpan>
                                            : pinAddress ? <SuccessMessageSpan>{pinAddress?.city}, {pinAddress?.state}</SuccessMessageSpan>
                                                : null
                                        }
                                    </InputMintDiv>
                                </Col>
                            </Row>
                            <PersonalDetailsSubmitButton type="submit" isMobile={isMobile}>Continue</PersonalDetailsSubmitButton>
                        </form>
                    </div>
                </PersonalFormSection>
            </PersonalDetailsWhiteCard>
        </WhiteCardWrapper>

    </div >);
};

export default PersonalDetails;

